/**
 * DetailTipContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Layout container for the detail tip (accessibility hint) row.
 */
const DetailTipContainer = styled.div`
  margin-bottom: ${Screen.widthRatio * 24}px;
  width: ${824 * Screen.widthRatio}px;
`;

export default DetailTipContainer;
